import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import RechargeRecord  from '../pages/mine/RechargeRecord'/* 提现记录 */
import Details from '../pages/mine/details'
import MoneyRecord from '../pages/mine/MoneyRecord'
import Booking from '../pages/lottery/booking.vue'
import Bookingsubmit from '../pages/lottery/bookingsubmit.vue'
import Bookinglist from '../pages/lottery/bookinglist.vue'
import BindUsdt from '../pages/mine/BindUsdt'
import RevenueRecord from '../pages/mine/RevenueRecord'

Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{titleKey:'foorter.index'}},
        {path:'/Home',name:'home',component:Home,meta:{titleKey:'land.brand'}},
        {path:'/Choose',name:'choose',component:Choose,meta:{titleKey:'foorter.xuanfei'}},
        {path:'/List',name:'list',component:List,meta:{titleKey:'foorter.xuanfei'}},
        {path:'/Profile',name:'profile',component:Profile,meta:{titleKey:'index.personal_profile'}},
        {path:'/Mine',name:'mine',component:Mine,meta:{titleKey:'foorter.my'}},
        {path:'/Video',name:'video',component:Video,meta:{titleKey:'foorter.subscribe'}},
        {path:'/Game',name:'game',component:Game,meta:{titleKey:'foorter.video'}},
        {path:'/Login',name:'login',component:Login,meta:{titleKey:'auth.login'}},
        {path:'/Register',name:'register',component:Register,meta:{titleKey:'auth.register'}},
        {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{titleKey:'my.online_service'}},
        {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{titleKey:'my.online_service'}},
        {path:'/Setting',name:'Setting',component:Setting,meta:{titleKey:'setting.setting'}},
        {path:'/Infomation',name:'Infomation',component:Infomation,meta:{titleKey:'my.basic_information'}},
        {path:'/Setname',name:'Setname',component:Setname,meta:{titleKey:'setting.modify_real_name'}},
        {path:'/Setsex',name:'Setsex',component:Setsex,meta:{titleKey:'setting.sex_place'}},
        {path:'/Language',name:'Language',component:Language,meta:{titleKey:'setting.language'}},
        {path:'/Recharge',name:'Recharge',component:Recharge,meta:{titleKey:'recharge.recharge'}},
        {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{titleKey:'setting.finance_pwd'}},
        {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{titleKey:'my.Login_password'}},
        {path:'/Lottery',name:'Lottery',component:Lottery,meta:{titleKey:'my.detail'}},
        {path:'/Booking',name:'Booking',component:Booking},
        {path:'/Bookingsubmit',name:'Bookingsubmit',component:Bookingsubmit},
        {path:'/Bookinglist',name:'Bookinglist',component:Bookinglist},
        {path:'/Notice',name:'Notice',component:Notice,meta:{titleKey:'my.information_announcement'}},
        {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{titleKey:'video.play'}},
        {path:'/Setbank',name:'Setbank',component:Setbank,meta:{titleKey:'my.msg39'}},
        {path:'/BindCard',name:'BindCard',component:BindCard,meta:{titleKey:'my.msg39'}},
        {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{titleKey:'my.withdraw'}},
        {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{titleKey:'my.my_statement'}},
        {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{titleKey:'withdraw.with_record'}},
        {path:'/RechargeRecord',name:'RechargeRecord',component:RechargeRecord,meta:{titleKey:'my.ti_record'}},
        {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{titleKey:'my.task_record'}},
        {path:'/MoneyRecord',name:'MoneyRecord',component:MoneyRecord,meta:{titleKey:'auth.top33'}},
        {path:'/BindUsdt',name:'BindUsdt',component:BindUsdt,meta:{titleKey:'my.msg40'}},
    {path:'/detail',name:'Details',component:Details},
	{path:'/RevenueRecord',name:'RevenueRecord',component:RevenueRecord,meta:{titleKey:'auth.msg38'}}
	

];

let i18nRef = null
const router = new VueRouter({
    routes
})
router.bindI18n = function (i18n) {
    i18nRef = i18n
}
router.beforeEach((to,from,next) => {
    const key = to.meta && to.meta.titleKey
    if (key && i18nRef) document.title = i18nRef.t(key)
    next()
})
router.afterEach((to) => {
    if (to.path === '/PlayVideo') {
        window.scrollTo(0, 0)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
    }
})

export default router